module.exports = __webpack_public_path__ + "img/2-3.b81cfa5d.svg";